import { Component, h } from "preact";
import { useContext } from "preact/hooks";

import {Config} from "../Store";
import Alert from "./Alert/Alert";
import SystemAlert from "./Alert/SystemAlert";

class AlertSection extends Component {
    constructor() {
        super();
        this.state = {
            openPanel: null
        };
    }

    handleClick(idx) {
        if (idx === this.state.openPanel) {
            this.setState({openPanel: null});
        } else {
            this.setState({openPanel: idx});
        }
    }

    render() {
        let { alerts } = this.props;
        let { systemWideAlerts } = useContext(Config);
        let systemAlerts = [];

        if (systemWideAlerts) {
        // separate the two types of alerts
            systemAlerts = alerts.filter(alert => alert.applies_systemwide);
            alerts = alerts.filter(alert => !alert.applies_systemwide);
        }

        return (
            <div>
                {systemAlerts.map((alert) => {
                    return (
                        <SystemAlert
                            alert={alert}
                            key={alert.transit_alert_id}
                        />
                    )
                })}
                {alerts.map((alert, idx) => {
                    let sectionNumber = (idx + 1).toString();
                    return (
                        <Alert
                            alert={alert}
                            key={alert.transit_alert_id}
                            label={sectionNumber}
                            isOpen={idx === this.state.openPanel}
                            handleClick={() => this.handleClick(idx)}
                        />
                    );
                })}
            </div>
        );
    }
}

export default AlertSection;



// WEBPACK FOOTER //
// ./components/AlertSection.js